<template>
  <div>
    <div class="hover-buttons" @mouseover="hide = false" @mouseleave="hide = true" :class="{ hide: hide && !home }">
      <button class="hover-btn" @click="toggleModal('Corpus')">
        O korpusie
      </button>
      <button class="hover-btn" @click="toggleModal('Team')">Zespół</button>
      <button class="hover-btn" @click="toggleModal('Method')">
        Metoda korpusowa
      </button>
      <button class="hover-btn" @click="toggleModal('PRL')">Prasa w PRL</button>
      <button class="hover-btn" @click="toggleModal('New')">Nowomowa</button>
      <button class="hover-btn" @click="toggleModal('Cite')">
        Jak cytować
      </button>
      <button class="hover-btn" @click="closeModal(), redirectUser('cases')">
        Scenariusze użycia
      </button>
    </div>

    <transition>
      <div class="about-modal" v-if="modalVisible" @click="closeModal">
        <div class="modal-body" v-on:click.stop>
          <button class="modal-close-btn" @click.prevent="closeModal">
            {{ $t("cross") }}
          </button>
          <div class="about-text">
            <span v-if="showCorpus">
              <h3>O korpusie</h3>
              <p>
                <br />
                Korpus i wyszukiwarka ChronoPress powstają w ramach prac konsorcjum naukowego „CLARIN – Polskie wspólne
                zasoby językowe i infrastruktura technologiczna”, finansowanego przez MNiSW i Unię Europejską. CLARIN-PL
                jest częścią „Polskiej Mapy Drogowej Infrastruktury Badawczej” oraz „European Roadmap for Research
                Infrastructures, European Strategy Forum on Research Infrastructures”. Liderem konsorcjum jest
                Politechnika Wrocławska.
                <br /><br />
                Korpus ChronoPress zawiera obecnie ok. 170.000 starannie dobranych fragmentów tekstów prasowych,
                opracowanych językowo na poziomie morfosyntaktycznym i oznaczonych
                metadanymi. Wszystkie fragmenty użyte są na zasadach cytatu. Próbki mają długość ok. 300 wyrazów
                tekstowych i reprezentują pełne spektrum tematyczne oficjalnego dyskursu publicznego lat 1945–1971 (od
                12 do 20 różnych tytułów gazet lub czasopism na rok). Docelowo korpus obejmie stulecie polskiej
                niepodległości (1918–2018).
                <br /><br />
                ChronoPress wykorzystuje lematyzator języka polskiego (Tager WCRFT2 z analizatorem morfologicznym
                Morfeusz), dzięki czemu możliwe jest generowanie charakterystyk podzbiorów złożonych z konkretnych
                części mowy. Jednak najważniejszą funkcjonalnością ChronoPressu jest analiza chronologiczna, ukazująca
                ewolucję frekwencji wybranych leksemów w czasie. Zasoby ChronoPressu są też stopniowo integrowane z
                aplikacjami rozwijanymi w ramach CLARIN-PL.
                <br /><br />
                Teksty pozyskano z zasobów polskich bibliotek akademickich – przede wszystkim Biblioteki Uniwersytetu
                Wrocławskiego i Zakładu Narodowego im. Ossolińskich. Wykorzystywano także cyfrowe wersje niektórych
                czasopism, udostępnione przez Federację Bibliotek Cyfrowych. Szczególną pomoc zdobyciu niektórych
                tekstów z 1945 roku okazały Biblioteka Uniwersytetu Warszawskiego, Centralna Biblioteka Wojskowa im.
                Józefa Piłsudskiego oraz Biblioteka Uniwersytecka im. Jerzego Giedroycia w Białymstoku.
                <br /><br />
              </p>
            </span>
            <span v-if="showMethod">
              <h3>Metoda korpusowa</h3>
              <br />
              <p>
                Metody korpusowe początkowo stosowane były jedynie w
                językoznawstwie jako swoisty symbol empiryzmu i przeciwwaga dla
                kierunków o silnym nastawieniu teoretycznym. Ich zwolennicy
                uważali, że teorie i modele wymyślane przez badaczy zza biurka i
                w zaciszu gabinetów (np. gramatyka generatywna) nie były
                osadzone w realiach „prawdziwego języka” – ten bowiem znaleźć
                można jedynie w korpusach tekstów. Dziś wiadomo, że spór ten był
                pozorny, a reprezentatywny korpus tekstów wraz z implementacją
                narzędzi ilościowych można wykorzystywać w wielu dyscyplinach
                humanistyki i nauk społecznych, a nie tylko w lingwistyce
                empirycznej. Zasób taki umożliwia eksplorację danych, prowadzącą
                do odkrycia parametrów ilościowych tekstu, a w dalszej
                kolejności niewidocznych z pozoru zależności i prawidłowości w
                rzeczywistości reprezentowanej lub kreowanej przez język. Dzięki
                wymiarowi ilościowemu i efektownym infografikom wyniki analizy
                korpusowej są bardziej przekonujące, niż luźne impresje z
                lektury. Zagregowane informacje generowane z ChronoPressu mogą
                posłużyć jako ilustracja lub podstawa badań w zakresie
                językoznawstwa, historii, antropologii kultury czy
                medioznawstwa. Cechy, które wyróżniają ChronoPress na tle innych
                narzędzi korpusowych, są następujące:
                <br />– zawartość (zrównoważone tematycznie próbki z trudno
                dostępnych tekstów prasowych z okresu Polski Ludowej); <br />–
                uporządkowanie chronologiczne (systematyczne daty wydań w formie
                metadanych, pozwalające na stosowanie różnych metod analizy
                chronologicznej); <br />– spójne i kompletne metadane.
              </p>
            </span>
            <span v-if="showPRL">
              <h3>Prasa w PRL, czyli rzeczywistość w krzywym zwierciadle</h3>
              <p>
                <br />
                Media państw totalitarnych nie relacjonują wiernie zdarzeń, lecz
                je deformują, tworząc w świadomości czytelników korzystny dla
                władzy obraz świata. Teksty prasowe z okresu PRL przedstawiają
                radosny obraz Polski Ludowej – wolnej, demokratycznej,
                szczęśliwej, postępowej i zwróconej ku przyszłości. Nie
                znajdziemy w nich wzmianek o postawach antykomunistycznych
                całych grup społecznych, o zbrodniach aparatu przemocy, o
                krzywdzie ludzkiej, o wasalizacji państwa, o patologicznej
                niewydolności ekonomicznej gospodarki socjalistycznej czy o
                nadużyciach aparatu władzy.
                <br /><br />
                Wśród najbardziej charakterystycznych cech języka tamtych lat
                wyróżnić możemy ostry podział na swoich i obcych, a także
                nachalne wartościowanie przedstawianych faktów, zdarzeń czy
                osób. Język propagandy, zwany za Georgem Orwellem nowomową, jest
                silnie zakłamany, ponieważ znaczenia słów są przeinaczane, a
                niekiedy wręcz odwracane w celu nadania tekstom oczekiwanego
                przez władzę wydźwięku. Ideologizacja języka w PRL osiąga poziom
                monstrualny w dobie stalinizmu (1949–1956), lecz w większym lub
                mniejszym stopniu obecna jest w całym okresie totalitaryzmu. O
                pewnym obiektywizmie prasy można mówić jedynie w odniesieniu do
                czysto faktograficznej warstwy tych działów tematycznych, którym
                daleko było do polityki (sport, kultura, sprawy obyczajowe lub
                relacje z krajów zamorskich).
                <br /><br />
                Korpus ChronoPress daje wgląd w dyskurs prasowy PRL. Nie jest on
                biblioteką cyfrową, ponieważ nie zawiera kompletnych wydań gazet
                i czasopism. Oferuje za to rzetelny i przekrojowy przegląd
                tematów prasy codziennej tamtych lat – lat, które ukształtowały
                obraz świata i wrażliwość komunikacyjną kilku pokoleń Polaków.
                Histogramy częstości (szeregi czasowe), profile leksykalne
                wyrazów, konkordancje czy listy frekwencyjne są syntezą wielkich
                ilości informacji, tworzoną dzięki narzędziom automatycznego
                przetwarzania języka wypracowanym w konsorcjum CLARIN-PL.
                Niewątpliwym walorem ChronoPressu jest także możliwość
                pozyskania doskonale opracowanego materiału językowego do
                wszelkich badań lingwistycznych.
                <br /><br />
                Lektura pojedynczych fragmentów prasy PRL, generowanych z
                korpusu ChronoPress, wymaga krytycznego i uważnego podejścia.
                Ale teksty prasy (i innych mediów) PRL możemy także analizować
                na dużych, przekrojowych zbiorach metodami humanistyki cyfrowej
                (podejście takie określane jest jako distant reading lub
                czytanie wspomagane). Przedmiotem analizy nie jest wtedy
                jednostkowy przekaz konkretnych artykułów, lecz niewidoczna
                podczas zwykłej lektury zawartość całych partii tekstu,
                drukowanych w ciągu wielu lat, ukrytych za doniesieniami
                agencyjnymi, publicystyką i wzmiankami o wydarzeniach bieżących.
                Można tym sposobem odkrywać
                <span class="underblue">wieloletnie procesy</span> (rozwój
                technologiczny, zmiany klimatyczne, emancypacja kobiet,
                pojawienie się fenomenu poprawności politycznej itd.),
                <span class="underblue">zjawiska cykliczne</span>, regulujące
                życie codzienne (prace rolnicze, cykle kulturowe, polityczne),
                ‘<span class="underblue">katastrofy</span>’, czyli zjawiska
                nagłe o silnym oddźwięku medialnym (śmierć znanej osoby,
                katastrofa naturalna lub techniczna, wojna, zmiana nazwy
                jakiegoś wielkiego miasta czy państwa itd.) oraz typowe dla
                mediów totalitarnych <span class="underblue">kampanie</span>,
                które miały mobilizować społeczeństwo wokół jakiegoś celu.
                <br /><br />
                Czy zapisy prasy tamtego okresu można uznać za częściową choćby
                prawdę historyczną? Kwestia jest trudna i nasuwa skojarzenie z
                biblijnym pytaniem Piłata podczas procesu Jezusa (Quid est
                veritas? / Czym jest prawda?). Z pewnością fragmenty ujęte w
                korpusie ChronoPress nie wyrażają doświadczenia ludzkiego
                tamtych czasów – tego można by co najwyżej szukać w działach
                drobnych ogłoszeń, których korpus nie zawiera. Obraz ówczesnej
                Polski jest podretuszowany, przesadnie optymistyczny, a przez to
                zdeformowany. Jest jednak ChronoPress dostępną dla każdego
                skarbnicą informacji bardzo konkretnych: nazwisk zapomnianych
                postaci, zdarzeń, których nie odnotowały kroniki, wzmianek o
                miejscach, opinii tworzonych pod presją chwili, wyrazów i fraz
                dawno nieużywanych i zapomnianych. W jakimś stopniu ocala tę
                pamięć dla potomnych.
              </p>
            </span>
            <span v-if="showTeam">
              <h3>Zespół</h3>
              <br />
              <p>
                Twórcą koncepcji i koordynatorem projektu korpusu ChronoPress
                jest prof. dr hab. Adam Pawłowski z Uniwersytetu Wrocławskiego
                (Instytut Informacji Naukowej i Bibliotekoznawstwa).
                Pozyskiwaniem materiału tekstowego zajmuje się zespół
                współpracowników z Uniwersytetu Wrocławskiego – głównie
                studentów, doktorantów i młodych absolwentów. Prace
                programistyczne, związane z przetwarzaniem danych tekstowych,
                integracją usług CLARIN-PL i przygotowaniem interfejsu,
                realizuje zespół współpracowników z Politechniki Wrocławskiej,
                kierowany przez dr. Tomasza Walkowiaka i mgr. inż. Tomasza
                Naskręta.
              </p>
            </span>
            <span v-if="showCite">
              <h3>Jak Cytować</h3>
              <br />
              <p>
                Cytowanie fragmentów opisów (np. scenariuszy użycia) oraz
                informacji generowanych przez aplikację ChronoPress (infografiki
                w postaci wykresów i tabel, listy frekwencyjne, konkordancje
                itd.) jest dozwolone i rekomendowane. Jednak zgodnie z dobrymi
                obyczajami akademickimi należy każdorazowo wskazać źródło wg
                następującego schematu:
                <br />
                <br />
                Pawłowski Adam (2021), ChronoPress – Korpus Tekstów Prasowych,
                doi:10.34616/139101.
                <br />
                Repozytorium CLARIN-PL:
                <a href="http://chronopress.clarin-pl.eu/" target="_blank"
                  title="Otwórz w nowej karcie">http://chronopress.clarin-pl.eu/</a>.
                <br />
              </p>
            </span>
            <div v-if="showNew">
              <h3>Nowomowa</h3>
              <br />
              <p>
                Mianem nowomowy określa się zniekształcony język publiczny
                państw totalitarnych, w szczególności komunistycznych i
                faszystowskich. Jego nazwa pochodzi od angielskiego wyrazu
                newspeak, użytego przez George’a Orwella w powieści „Rok 1984”,
                ukończonej tuż po zakończeniu drugiej wojny światowej. Orwell
                wprowadził tam schematy zaobserwowane w propagandzie i
                funkcjonowaniu kształtujących się w XX wieku państw
                totalitarnych Europy – Hiszpanii, Niemiec Hitlerowskich, a
                przede wszystkim Rosji Sowieckiej.
              </p>
              <p>
                Oto w fikcyjnym państwie Oceania (nawiązanie do mitycznej
                Atlantydy) władza stworzyła nowy język i narzuciła go
                społeczeństwu, odcinając je od języka ‘starego’. Język nowy miał
                być narzędziem kontroli słów i myśli mieszkańców Oceanii, a w
                konsekwencji także ich zachowania. Determinował światopogląd,
                ponieważ uniemożliwiał wyrażenie idei czy pojęć niezgodnych z
                oficjalną doktryną. Dokonano tego, usuwając niepożądane wyrazy,
                a tym, które pozostały, często zmieniono znaczenia. Osoby, które
                mimo braku odpowiednich słów pomyślałyby o tym, co wykraczało
                poza oficjalną ideologię, popełniały tzw. ‘myślozbrodnię’.
              </p>
              <p>
                Wśród cech nowomowy wymienia się m.in.:
                <span class="underblue">permanentne wartościowanie</span>
                (wszystko jest albo dobre, albo złe),
                <span class="underblue">rytualność</span> (powtarzanie do
                znudzenia tych samych formuł),
                <span class="underblue">etykietowanie</span> (systematyczne
                „przyklejanie” konkretnym osobom, ale też organizacjom,
                zdarzeniom i całym państwom stygmatyzujących epitetów,
                utrudniających obiektywizm ocen),
                <span class="underblue">perswazyjność</span> (teksty nie
                informują, lecz przekonują),
                <span class="underblue">dominację funkcji magicznej</span> (samo
                wypowiadanie słów, na przykład sloganu, ma tworzyć nową
                rzeczywistość) i
                <span class="underblue">obecność figury wroga</span> (np.
                kapitalizmu, rewanżystów zachodnioniemieckich, band reakcyjnych,
                postaci kułaka, szpiega imperialistycznego, polityków
                sanacyjnych itd.).
              </p>
              <p>
                Powieść Orwella należy do gatunku dystopii, czyli utopii
                katastroficznych. „Rok 1984” zyskał na całym świecie wielką
                popularność, stając się kulturowym symbolem totalitaryzmu.
                Świadczy o tym liczba jego wydań, tłumaczeń oraz filmów,
                opartych na pomyśle Orwella.
              </p>
            </div>
          </div>
          <span v-if="showUsage">
            <usage-guide />
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SideTabs",
  components: {},
  props: [],
  data() {
    return {
      list: [],
      modalVisible: false,
      showCorpus: false,
      showPRL: false,
      showMethod: false,
      showTeam: false,
      showUsage: false,
      showCite: false,
      showNew: false,
      hide: true,
      home: true,
    };
  },
  computed: {},
  methods: {
    redirectUser: function (path) {
      this.$router.push(path);
    },
    resetSection() {
      this.showCorpus = false;
      this.showTeam = false;
      this.showMethod = false;
      this.showPRL = false;
      this.showUsage = false;
      this.showCite = false;
      this.showNew = false;
    },
    toggleModal(section) {
      this.resetSection();
      this.modalVisible = true;
      if (section === "Corpus") {
        this.showCorpus = true;
      } else if (section === "Tools") {
        this.showTools = true;
      } else if (section === "Team") {
        this.showTeam = true;
      } else if (section === "PRL") {
        this.showPRL = true;
      } else if (section === "usage") {
        this.showUsage = true;
      } else if (section === "Method") {
        this.showMethod = true;
      } else if (section === "Cite") {
        this.showCite = true;
      } else if (section === "New") {
        this.showNew = true;
      }
      this.redirectUser("home");
      this.hide = true;
      this.home = false;
    },
    closeModal() {
      this.home = true;
      this.modalVisible = false;
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === "Home") {
        this.home = false;
      } else {
        this.home = false;
      }
    },
  },
  mounted() {
    if (this.$route.name === "Home") {
      this.home = true;
    } else {
      this.home = false;
    }
    this.hide = false;
    this.home = true;
  },
};
</script>

<style scoped>
.hover-buttons {
  z-index: 9999;
  position: absolute;
  top: 0%;
  left: 0%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease-in-out;
}

.hover-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 12rem;
  color: rgb(0, 0, 0);
  background-color: rgb(255, 255, 255);
  margin-bottom: 1rem;
  border: none;
  outline: none;
  padding-top: 0.2rem;
  box-shadow: 0 3px 10px rgb(65, 65, 65);
}

.hover-btn:hover {
  transform: scaleX(1.05);
  color: white;
  background-color: var(--grey_black);
  box-shadow: 0 0 5px #0f0f0f75;
}

@media only screen and (max-width: 768px) {
  .modal-body {
    margin: 0 5vw !important;
  }

  .modal-body span {
    width: 100%;
  }
}

.about-modal {
  z-index: 9998;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(185, 185, 185, 0.534);
}

.modal-body {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40%;
  max-height: 80%;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 5px 15px #0f0f0fdd;
  margin: 0 15vw;
  padding-top: 4rem;
  overflow: hidden;
}

.modal-close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 3rem;
  height: 3rem;
  color: rgb(105, 105, 105);
  background-color: white;
  border: none;
  outline: none;
  font-weight: bold;
}

.modal-close-btn:hover {
  font-size: 1.2rem;
}

.about {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 80%;
  margin-top: 2rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  margin-bottom: 3rem;
  margin-bottom: 1rem;
  background-color: rgba(255, 255, 255, 0.542);
}

.about-text {
  width: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1rem;
  background-color: rgb(255, 255, 255);
  line-height: 26px;
  overflow-y: auto;
  overflow-x: hidden;
}

.about-text p {
  text-justify: inter-character;
  text-align: justify;
  font-size: 20px;
}

.about p {
  text-justify: newspaper;
}

.about-text span p {
  text-justify: newspaper;
}

.underblue {
  color: #288cb8;
}

.hide {
  left: -160px;
}

.my-tooltip {
  cursor: pointer;
  position: relative;
  display: inline-block;
  color: #ff8839;
  border-bottom: 1px dotted black;
  border-radius: initial;
}

.my-tooltip .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: rgb(255, 255, 255);
  border: 2px solid #292929;
  color: rgb(0, 0, 0);
  text-align: center;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -150px;
  text-align: justify;
  text-justify: inter-character;
  padding: 1rem;
  font-weight: normal;
}

.my-tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.my-tooltip:hover {
  color: black;
  background-color: #febf94;
}

.my-tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/SideTabs.vue